import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGridOperatorCapacities } from 'app/entities/grid-operator-capacity/grid-operator-capacity.reducer';
import { createEntity, getEntity, reset, updateEntity } from './grid-operator-capacity-tariff.reducer';

export const GridOperatorCapacityTariffUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const gridOperatorCapacities = useAppSelector(state => state.gridOperatorCapacity.entities);
  const gridOperatorCapacityTariffEntity = useAppSelector(state => state.gridOperatorCapacityTariff.entity);
  const loading = useAppSelector(state => state.gridOperatorCapacityTariff.loading);
  const updating = useAppSelector(state => state.gridOperatorCapacityTariff.updating);
  const updateSuccess = useAppSelector(state => state.gridOperatorCapacityTariff.updateSuccess);

  const handleClose = () => {
    navigate('/grid-operator-capacity-tariff');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGridOperatorCapacities({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.tariff !== undefined && typeof values.tariff !== 'number') {
      values.tariff = Number(values.tariff);
    }

    const entity = {
      ...gridOperatorCapacityTariffEntity,
      ...values,
      gridOperatorCapacity: gridOperatorCapacities.find(
        it => it.id.toString() === values.gridOperatorCapacity?.toString(),
      ),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...gridOperatorCapacityTariffEntity,
          gridOperatorCapacity: gridOperatorCapacityTariffEntity?.gridOperatorCapacity?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="crawlerBackendApp.gridOperatorCapacityTariff.home.createOrEditLabel"
            data-cy="GridOperatorCapacityTariffCreateUpdateHeading"
          >
            <Translate contentKey="crawlerBackendApp.gridOperatorCapacityTariff.home.createOrEditLabel">
              Create or edit a GridOperatorCapacityTariff
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="grid-operator-capacity-tariff-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.gridOperatorCapacityTariff.tariff')}
                id="grid-operator-capacity-tariff-tariff"
                name="tariff"
                data-cy="tariff"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.gridOperatorCapacityTariff.effectiveDate')}
                id="grid-operator-capacity-tariff-effectiveDate"
                name="effectiveDate"
                data-cy="effectiveDate"
                type="date"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.gridOperatorCapacityTariff.expirationDate')}
                id="grid-operator-capacity-tariff-expirationDate"
                name="expirationDate"
                data-cy="expirationDate"
                type="date"
              />
              <ValidatedField
                id="grid-operator-capacity-tariff-gridOperatorCapacity"
                name="gridOperatorCapacity"
                data-cy="gridOperatorCapacity"
                label={translate('crawlerBackendApp.gridOperatorCapacityTariff.gridOperatorCapacity')}
                type="select"
              >
                <option value="" key="0" />
                {gridOperatorCapacities
                  ? gridOperatorCapacities.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.capacityCode}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/grid-operator-capacity-tariff"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default GridOperatorCapacityTariffUpdate;
